import { get } from '../api/api';

export function cacheEnums(token) {
    const enums = localStorage.getItem('enums')
    if (!enums) {
      return new Promise(function (resolve, reject) {
        get('/enums', null, {
          token: token,
        }).then((res) => {
          localStorage.setItem('enums', JSON.stringify(res.data));
          resolve(res.data);
        });
      });
    }
    else
      return new Promise(function (resolve, reject) {
        resolve(JSON.parse(enums));
      });
  }

  export function cacheAssets(token) {
    const assets = localStorage.getItem('assets')
    if (!assets) {
      return new Promise(function (resolve, reject) {
        get('/assets?limit=0', null, {
          token: token,
        }).then((res) => {
            const assetIndex =
            Object.fromEntries(res.data
                .map((asset) => [ asset.id, asset ]));
          localStorage.setItem('assets', JSON.stringify(assetIndex));
          resolve(assetIndex);
        });
      });
    }
    else
      return new Promise(function (resolve, reject) {
        resolve(JSON.parse(assets));
      });
  }